import { render, staticRenderFns } from "./applyVip.vue?vue&type=template&id=66d2b6d4&scoped=true&"
import script from "./applyVip.vue?vue&type=script&lang=js&"
export * from "./applyVip.vue?vue&type=script&lang=js&"
import style0 from "./applyVip.vue?vue&type=style&index=0&id=66d2b6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d2b6d4",
  null
  
)

export default component.exports